import { WithHint } from '../../../../ui/feedback/Tooltip';

export const buildBusinessTabs = (businessId: string, t: (key: string) => string) => {
    if (!businessId) {
        return [];
    }

    const allPostsLabel = t('Все посты');

    return [
        {
            value: `/businesses/${businessId}`,
            label: t('Опубликовано'),
        },
        {
            value: `/businesses/${businessId}/moderation`,
            label: (
                <WithHint
                    message={
                        'В этой вкладке находятся все посты: опубликованные/ на модерации/ отклоненные.\n\nЧерновики можно найти в разделе "Управление лентой"'
                    }
                >
                    {allPostsLabel}
                </WithHint>
            ),
        },
    ];
};
